import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { GiftCatalogCardSkeleton } from '../../../molecules/gift-catalog-card/gift-catalog-card.tsx';
export const GiftCatalogCoreSkeleton: React.FC<{
  itemCount?: number;
}> = t0 => {
  const $ = _c(27);
  const {
    itemCount: t1
  } = t0;
  const itemCount = t1 === undefined ? 9 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "min(22rem, 92%)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const headerTitleStyle = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "min(36rem, 96%)"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const headerSubtitleStyle = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [116, 148, 134, 124, 152, 136, 120, 142, 118, 128, 144, 126].map(_temp);
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const filterChipSkeletons = t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [86, 108, 94];
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const mainChipSkeletons = t5;
  let t6;
  if ($[4] !== itemCount) {
    t6 = Array.from({
      length: itemCount
    }, _temp2);
    $[4] = itemCount;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const cardSkeletonKeys = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex-1"><div className="flex flex-col gap-snug-sm"><Skeleton height={42} style={headerTitleStyle} /><Skeleton height={20} style={headerSubtitleStyle} /></div></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="GiftCatalogCore__filterToggle md:hidden flex-1"><div className="GiftCatalogCore__filterButton flex items-center justify-between gap-snug-sm rounded-lg border border-neutral-mild px-comfy-sm py-snug-sm"><Skeleton height={18} width="65%" /><Skeleton height={18} width={20} borderRadius="9999px" /></div></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="hidden md:block"><Skeleton height={16} width={90} /></div>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="GiftCatalogCore__header flex flex-col gap-comfy-md md:items-end md:flex-row">{t7}<div className="flex gap-comfy-sm w-full md:w-auto">{t8}<div className="GiftCatalogCore__sort grid gap-snug-md relative flex-1 md:flex-none md:w-60">{t9}<div className="rounded-lg border border-neutral-mild px-comfy-sm py-snug-sm"><Skeleton height={18} width="100%" /></div></div></div></div>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Skeleton height={22} style={{
      width: "7.5rem"
    }} />;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="GiftCatalogCore__filtersHeader flex items-center justify-between">{t11}<Skeleton height={16} style={{
        width: "4.25rem"
      }} /></div>;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="GiftCatalogCore__filterButton justify-between -mx-comfy-xs mt-comfy-xs mb-comfy-xs flex items-center gap-snug-sm rounded-lg border border-neutral-mild px-comfy-sm py-snug-sm"><Skeleton height={18} style={{
        width: "8.5rem"
      }} /><Skeleton height={18} width={20} borderRadius="9999px" /></div>;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="GiftCatalogCore__filterSection grid gap-snug-md">{t13}<div className="GiftCatalogCore__filterBody pb-comfy-sm grid gap-snug-md"><div className="flex flex-wrap gap-snug-sm">{filterChipSkeletons.map(_temp3)}</div></div></div>;
    t15 = <hr className="GiftCatalogCore__divider block m-none" />;
    $[13] = t14;
    $[14] = t15;
  } else {
    t14 = $[13];
    t15 = $[14];
  }
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="GiftCatalogCore__filterButton justify-between -mx-comfy-xs mt-comfy-xs mb-comfy-xs flex items-center gap-snug-sm rounded-lg border border-neutral-mild px-comfy-sm py-snug-sm"><Skeleton height={18} style={{
        width: "9rem"
      }} /><Skeleton height={18} width={20} borderRadius="9999px" /></div>;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Skeleton height={16} style={{
      width: "7rem"
    }} />;
    $[16] = t17;
  } else {
    t17 = $[16];
  }
  let t18;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Skeleton height={10} width="100%" borderRadius="9999px" />;
    $[17] = t18;
  } else {
    t18 = $[17];
  }
  let t19;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="grid gap-snug-xxs"><Skeleton height={10} width={52} /><Skeleton height={22} width={64} /></div>;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <aside className="GiftCatalogCore__filters hidden md:grid px-comfy-sm py-comfy-lg rounded-lg gap-comfy-md">{t12}{t14}{t15}<div className="GiftCatalogCore__filterSection grid gap-snug-md">{t16}<div className="GiftCatalogCore__filterBody pb-comfy-sm grid gap-snug-md">{t17}<div className="grid gap-snug-xs">{t18}<div className="flex justify-between gap-snug-lg">{t19}<div className="grid gap-snug-xxs"><Skeleton height={10} width={68} /><Skeleton height={22} width={64} /></div></div></div></div></div></aside>;
    $[19] = t20;
  } else {
    t20 = $[19];
  }
  let t21;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Skeleton height={20} style={{
      width: "15rem"
    }} />;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  let t22;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="grid gap-snug-sm">{t21}<div className="flex flex-wrap gap-snug-sm">{mainChipSkeletons.map(_temp4)}</div></div>;
    $[21] = t22;
  } else {
    t22 = $[21];
  }
  let t23;
  if ($[22] !== cardSkeletonKeys) {
    t23 = <div className="grid gap-comfy-sm @md:gap-comfy-lg grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3">{cardSkeletonKeys.map(_temp5)}</div>;
    $[22] = cardSkeletonKeys;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="flex justify-center mt-comfy-lg"><Skeleton height={48} width={200} borderRadius="9999px" /></div>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] !== t23) {
    t25 = <section className="GiftCatalogCore component"><div className="GiftCatalogCore__container container grid gap-comfy-sm md:gap-comfy-xl">{t10}<div className="GiftCatalogCore__body grid items-start gap-comfy-lg md:grid-cols-[minmax(0,280px)_1fr]">{t20}<div className="GiftCatalogCore__main grid gap-comfy-lg">{t22}{t23}{t24}</div></div></div></section>;
    $[25] = t23;
    $[26] = t25;
  } else {
    t25 = $[26];
  }
  return t25;
};
export const GiftCatalogCoreCardsSkeleton: React.FC<{
  itemCount?: number;
}> = t0 => {
  const $ = _c(7);
  const {
    itemCount: t1
  } = t0;
  const itemCount = t1 === undefined ? 9 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [88, 110, 96];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const summaryChipWidths = t2;
  let t3;
  if ($[1] !== itemCount) {
    t3 = Array.from({
      length: itemCount
    }, _temp6);
    $[1] = itemCount;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const cardSkeletonKeys = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton height={20} style={{
      width: "15rem"
    }} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="grid gap-snug-sm">{t4}<div className="flex flex-wrap gap-snug-sm">{summaryChipWidths.map(_temp7)}</div></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== cardSkeletonKeys) {
    t6 = <>{t5}<div className="grid gap-comfy-sm @md:gap-comfy-lg grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3">{cardSkeletonKeys.map(_temp8)}</div></>;
    $[5] = cardSkeletonKeys;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
function _temp(width, idx) {
  return {
    key: `gift-filter-chip-${idx + 1}`,
    width
  };
}
function _temp2(_, idx_0) {
  return `gift-catalog-card-skeleton-${idx_0 + 1}`;
}
function _temp3(t0) {
  const {
    key,
    width: width_0
  } = t0;
  return <Skeleton key={key} height={32} width={width_0} borderRadius="9999px" />;
}
function _temp4(width_1, idx_1) {
  return <Skeleton key={`gift-main-chip-${idx_1 + 1}`} height={28} width={width_1} borderRadius="9999px" />;
}
function _temp5(key_0) {
  return <GiftCatalogCardSkeleton key={key_0} />;
}
function _temp6(_, idx) {
  return `gift-catalog-card-skeleton-inline-${idx + 1}`;
}
function _temp7(width, idx_0) {
  return <Skeleton key={`gift-summary-chip-${idx_0 + 1}`} height={28} width={width} borderRadius="9999px" />;
}
function _temp8(key) {
  return <GiftCatalogCardSkeleton key={key} />;
}